import { CheckboxElement } from 'react-hook-form-mui';

import type { ReactNode } from 'react';

import { useAppTranslations } from '@treneo/shared/i18n';

import { translateErrorMessage } from '../constants/form-constants';

type Props = {
  name: string;
  label: string | ReactNode;
  disabled?: boolean;
};

export const CheckboxField = ({ name, label, disabled }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  const parseError = (error: unknown) => {
    const message = translateErrorMessage(error);
    if (!message) {
      return '';
    }
    const translated = t(message);
    const hasTranslation = translated !== message;
    return hasTranslation ? translated : message;
  };

  return <CheckboxElement name={name} label={label} parseError={parseError} disabled={disabled} />;
};
